import support from "./support";

const menuItems = {
  items: [support],
};

export default menuItems;
